import angular from 'angular';
import ngResource from 'angular-resource';
import config from '../../config/config';

import locationsService from './locations.service';

const locationsModule = angular.module('locations', [
    ngResource,
    config
])
    .service('locationsService', locationsService)
    .name;

export default locationsModule;


// WEBPACK FOOTER //
// ./client/app/api/locations/locations.js